import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HubspotCertificationIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { EVENTS } from '../constants/Events';
import Tracker from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AppInfoTitle = ({
  providerDomain,
  providerName,
  appId,
  showCertificationIcon
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      gap: "300",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-400",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: providerName
        })
      }), showCertificationIcon && /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        gap: "200",
        flexShrink: 0,
        children: [/*#__PURE__*/_jsx(HubspotCertificationIcon, {
          color: "fill-brand-default",
          size: "700"
        }), /*#__PURE__*/_jsx(Text, {
          as: "h6",
          textTransform: "uppercase",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "oauth.app.certified"
          })
        })]
      })]
    }), providerDomain && /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Link
      },
      options: {
        domain: providerDomain,
        href: `https://${providerDomain}`,
        onClick: () => {
          Tracker.track(EVENTS.VERIFIED_DOMAIN_CLICK, {
            applicationId: appId,
            applicationName: providerName,
            domain: providerDomain
          });
        }
      },
      message: "oauth.authorization.appBy_jsx"
    })]
  });
};
export default AppInfoTitle;